/**
 * Format date as per format
 * @param date 
 * @param format 
 * @returns 
 */
const dateConversion = (date: string, format: string) => {
    let formattedDate: string = '';
    if (date && date != "") {
        const dateObject: Date = new Date(date);
        if (format === 'MMMM d, yyyy') {
            formattedDate = dateObject.toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            });
        }
    }
    return formattedDate;
}

/**
 * Format date YYYY-MM-DD
 * @param date 
 * @returns 
 */
const formatDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * UTC full date
 * @param date 
 * @returns 
 */
 const toUTCFormatDate = (date: Date): string => {
  const pad = (n: number) => String(n).padStart(2, "0");

  const yyyy = date.getUTCFullYear();
  const MM = pad(date.getUTCMonth() + 1);
  const dd = pad(date.getUTCDate());
  const HH = pad(date.getUTCHours());
  const mm = pad(date.getUTCMinutes());
  const ss = pad(date.getUTCSeconds());
  const ms = String(date.getUTCMilliseconds()).padStart(3, "0");

  return `${yyyy}-${MM}-${dd}T${HH}:${mm}:${ss}`;
};

export {
    dateConversion,
    formatDate,
    toUTCFormatDate
}